const COLORS = {
    PASS: "#3aa057",
    FAIL: "#ff6666",
    NEUTRAL: "#adadad",
    PASSED: "#3aa057",
    FAILED: "#ff6666",
    INTERRUPTED: "#adadad",
    UNKNOWN: "rgb(255, 69, 176)",
    CAR: "#52b152",
    TRUCK: "#45b28e",
    MOTORBIKE: "#4592b2",
    BICYCLE: "#b28345",
    "STATIC OBJECT": "#b24573",
    PEDESTRIAN: "rgb(255, 69, 176)",
    "E-SCOOTER": "#45b273",
    RESERVED: "#b28345",
    STATIONARY: "#846bb2",
    MOVING: "#b28394",
    BRAKING: "#b26b94",
    CROSSING: "#6b94b2",
    ONCOMING: "#6b84b2",
    TURNING: "#b29a6b",
    FCTW: "#6bb284",
    EURONCAP2023: "#2a6f97",
    "HONDA ORIGINAL": "#ff7f11",
    "HONDA A-REQUEST": "#d7263d",
    "HONDA TEAM-REQUEST": "#1f77b4",
    "HONDA FCTW": "#bc5090",
    "HONDA HEADON": "#ffa600",
    "HONDA PRECMBS": "#003f5c",
    JNCAP2022: "#665191",
    CNCAP2024: "#7a5195",
    USNCAP2019: "#ef5675",
    CIASIVER3: "#ffa600",
    IIHS2025: "#ff6e54",
    "USNCAP2015_CIB": "#dd5182",
    "USNCAP2015_DBS": "#955196",
    "UN-R152": "#2a9d8f",
    GBT: "#264653",
    "US AEB REGULATION": "#e76f51"
  };
  
  export default COLORS;
  